import request from "../Utils/request";

export function updateData(url: string, data?: any) {
  return request.patch(url, data);
}
